import React, { useEffect, useState } from "react";
import { linkedinConfig, urlEntrarLinkedin } from "../services/api";

/**
 * 🔗 "CONTINUAR COM O LINKEDIN" (29/09/2026). Diferente do Google, não há botão pronto que devolve o token:
 * o clique leva a pessoa ao LinkedIn e ela volta em /entrar#li=… (ver LoginPage). Só candidato.
 * O botão só aparece quando o servidor diz que está ativo (Client ID + Client Secret no cofre).
 */
export default function BotaoLinkedin({ destino }) {
  const [ativo, setAtivo] = useState(false);
  useEffect(() => { linkedinConfig().then((r) => setAtivo(!!r?.ativo)).catch(() => setAtivo(false)); }, []);
  if (!ativo) return null;
  return (
    <a href={urlEntrarLinkedin(destino)}
       className="mx-auto mb-3 flex w-full max-w-[400px] items-center justify-center gap-2 rounded-full border border-[#0A66C2] bg-white px-4 py-2.5 text-sm font-semibold text-[#0A66C2] hover:bg-[#0A66C2]/5">
      <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true"><path fill="#0A66C2" d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.34V9h3.42v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13zM7.12 20.45H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.73V1.73C24 .77 23.2 0 22.22 0z"/></svg>
      Continuar com o LinkedIn
    </a>
  );
}
